{
  "navbar": {
    "logout": "注销"
  }
}
